import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface Correlation {
  symbol_a: string;
  symbol_b: string;
  correlation: number;
  period_days: number;
  computed_at: string;
}

export function useCorrelations() {
  const query = useQuery({
    queryKey: ['asset-correlations'],
    queryFn: async (): Promise<Correlation[]> => {
      const { data, error } = await supabase
        .from('asset_correlations')
        .select('symbol_a, symbol_b, correlation, period_days, computed_at');

      if (error) throw error;
      return (data || []) as Correlation[];
    },
    staleTime: 3600000, // 1 hour
  });

  const getCorrelation = (symbolA: string, symbolB: string): number | null => {
    if (!query.data) return null;
    const [a, b] = [symbolA, symbolB].sort();
    const found = query.data.find(
      (c) => c.symbol_a === a && c.symbol_b === b,
    );
    return found ? found.correlation : null;
  };

  return {
    correlations: query.data || [],
    isLoading: query.isLoading,
    error: query.error,
    getCorrelation,
  };
}
